module.exports = __webpack_public_path__ + "static/media/spring.f97cfb8e.png";